<template>
  <!-- 专家帐号 -->
  <yioks-content @back="handleBack">
    <template v-slot:nav_left>
      <div class="nav-btn-box">待评估机构列表</div>
    </template>

    <template v-slot:nav_right>
      <!-- v-if="canEdit" <div  class="yioks_btn" @click="handleEditSort">点击编辑申报评估排名</div> -->
      <div  class="yioks_btn" @click="scoreSummaryFile" v-if="stage_info.open">第五步：专家汇总表</div>
      <div  class="yioks_btn" @click="getBaseScoreFileSummary()" v-else>专家汇总表</div>
    </template>

    <template v-slot:content_right>
      <div class="base-content-wrapper">
        <div class="content-inner-wrapper">
          <div class="select_wrap">
            <div class="select_box left">
              <select v-model="filterData.organUuid" class="yioks_select" @change="changeQuery(true)" >
                <option value='' v-if="organList.length !== 1">全部区体育行政部门</option>
                <option
                  v-for="item in organList"
                  :key="item.value"
                  :value="item.uuid"
                >{{ item.organShortName }}</option>
              </select>
              <!-- <select v-model="filterData.cityCode" class="yioks_select" @change="changeQuery(true)" >
                <option value='' v-if="organList.length !== 1">全部城市</option>
                <option
                  v-for="item in select_city_list"
                  :key="item.code"
                  :value="item.code"
                >{{ item.name }}</option>
              </select> -->
              <select
                v-model="filterData.countyCode"
                class="yioks_select"
                @change="handleCountyChange(filterData.countyCode)"
              >
                <option value="" v-if="organList.length !== 1">
                  所属区域
                </option>
                <option :value="'0'">上海市</option>
                <option
                  v-for="item in sh_county_list"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <select
                v-model="filterData.stageApplyType"
                class="yioks_select"
                @change="changeQuery(true)"
              >
                <option value="">全部申报类型</option>
                <option
                  v-for="item in stageTypeListForSystemSearch"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
            <div class="select_box right">
              <input
                v-model.trim="filterData.stageName"
                type="text"
                class="yioks_input"
                style="width: 160px"
                placeholder="请输入关键字"
                @keyup.enter="changeQuery(true)"
              />
              <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
            </div>
          </div>

          <div class="list_wrap" v-if="!loading && !empty">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq">序号</div>
                  <div class="th youthName">
                    <div>申报单位</div>
<!--                    <div v-if="!isInClubSystem">-->
<!--                      (<span class="suc"-->
<!--                        >加<i class="el-icon-star-on"></i>评定区级青训中心</span-->
<!--                      >)-->
<!--                    </div>-->
                  </div>
                  <!-- <div class="th youthShortName">管理员</div> -->
                  <div class="th score">申报类型</div>
                  <div class="th submit">管理单位</div>
                  <!-- <div class="th auditScore">初审区排名</div>
                  <div class="th orgAuditState">初审结果</div>
                  <div class="th audit">区级青训中心推荐</div>
                  <div class="th adminAuditState">终审结果</div> -->
                  <div class="th adminAuditState" v-if="false">审核状态</div>
                  <div class="th action">操作</div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in pageList"
                        :key="index"
                      >
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td youthName">
                          <p :title="item.youthShortName">
                            {{ item.youthShortName }}
                            <template v-if="!isInClubSystem">
                              <span
                                v-if="item.adminRecommendUuid"
                                class="suc"
                                title="推荐"
                                >(<i class="el-icon-star-on"></i>)</span
                              >
                            </template>
                          </p>
                        </div>
                        <!-- <div class="td youthShortName">
                          <p :title="item.adminName">{{ item.adminName }}</p>
                        </div> -->
                        <div class="td score">
                          <p :title="item.stageApplyType">{{ item.stageApplyType || "--" }}</p>
                        </div>
<!--                        <div class="td submit">-->
<!--                          <p :title="`初审单位：${item.organShortName}`">-->
<!--                            <span v-if="item.countyName">{{-->
<!--                              item.countyName || "&#45;&#45;"-->
<!--                            }}</span>-->
<!--                            <span v-else>{{ item.cityName || "&#45;&#45;" }}</span>-->
<!--                          </p>-->
<!--                        </div>-->
                        <div class="td submit">
                          <p :title="`所属区域：${item.cityName}${item.countyName}`">
                            <span>{{item.organShortName || "--"}}</span>
                          </p>
                        </div>

                        <!-- <div class="td auditScore">
                          <p v-if="item.orgSort" :title="item.orgSort">
                            第&nbsp;{{ item.orgSort }}&nbsp;名
                          </p>
                          <p v-else>未排名</p>
                        </div>
                        <div class="td orgAuditState">
                          <p>{{ item.orgAuditState | auditStateFilters }}</p>
                        </div>
                        <div class="td audit">
                          <p>{{ item.orgRecommend ? "推荐" : "--" }}</p>
                        </div>
                        <div class="td adminAuditState">
                          <p>{{ item.adminAuditState | auditStateFilters }}</p>
                        </div> -->
                        <div class="td adminAuditState" v-if="false">
                          <template>
                            <p v-if="!item.audit">
                              <span>未审核</span>
                            </p>
                            <p v-else>
                              <span>已审核</span>
                            </p>
                          </template>
                        </div>
                        <div class="td action">
                          <template v-if="canEdit">
                            <div style="display: block;text-align: center;padding: 10px;">
                              <p v-if="!item.audit">
                                <span class="item active" @click="handleListAction('audit', item)">第二步：评估材料</span>
                              </p>
                              <p v-if="!item.audit">
                                <span
                                  class="item active"
                                  @click="goInfo(item.youthUuid)"
                                >
                               第三步：日常管理</span>
                              </p>
                              <p v-else>
                                <span class="item active" @click="handleListAction('find', item)">查看</span>
                                <span
                                  class="item active"
                                  @click="goInfo(item.youthUuid)"
                                >
                              / 日常管理</span>
                              </p>
                              <p style="margin-top:2px">
                              <span
                                class="item active"
                                @click="uploadScoreReport(item.youthUuid)"
                                v-if="stage_info.open"
                              >
                              第四步：专家评分表</span>
                                <span
                                  class="item active"
                                  @click="getBaseScoreFile(item.youthUuid)"
                                  v-else
                                >
                              专家评分表</span>
                              </p>
                            </div>
                          </template>
                          <template v-else>
                            <div style="display: block;text-align: center;padding: 10px;">
                              <p >
                                <!-- 评估关闭时，仅允余查看 -->

                                <span
                                  class="item active"
                                  @click="handleListAction('find', item)"
                                >
                              评估材料<span class="item" v-if="item.auditState === 1" style="color:white">(审核通过)</span>
                              <span class="item" v-if="item.auditState === 2" style="color:white">(审核拒绝)</span>
                              <span class="item" v-if="item.auditState === 3" style="color:white">(继续完善)</span></span>
                                <span
                                  class="item active"
                                  @click="goInfo(item.youthUuid)"
                                >
                              / 日常管理</span>
                              </p>
                              <p style="margin-top:2px">
                              <span
                                class="item active"
                                @click="uploadScoreReport(item.youthUuid)"
                                v-if="stage_info.open"
                              >
                              专家评分表</span>
                              <span
                                class="item active"
                                @click="getBaseScoreFile(item.youthUuid)"
                                v-else
                              >
                              专家评分表</span>
                              </p>
                            </div>

                          </template>

                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>

          <yioks-loading v-if="loading"></yioks-loading>
          <yioks-empty v-if="!loading && empty"></yioks-empty>

          <!-- 排名弹窗 -->
          <template v-if="isShowSortDialog">
            <sort-dialog
              :isShow.sync="isShowSortDialog"
              :infoList="pageList"
              :groupUuid="groupUuid"
              :stageUuid="stageUuid"
              :propsType="propsType"
              @callback="handleCallback"
            ></sort-dialog>
          </template>
        </div>
      </div>

      <yioks-pagination :page.sync="page" :total="total"></yioks-pagination>

      <template v-if="isUpload">
        <upload-dialog
          :isOpen.sync="isUpload"
          :isEdit="isEditMode"
          :stageUuid="stageUuid"
          :youthUuid="youthUuid"
          @closeDialogCallBack="handleUploadCallBack"
        ></upload-dialog>
      </template>
      <template v-if="isUploadSummary">
        <upload-dialog-Summary
          :isOpen.sync="isUploadSummary"
          :isEdit="isEditMode"
          :stageUuid="stageUuid"
          @closeDialogCallBackSummary="handleUploadCallBackSummary"
        ></upload-dialog-Summary>
      </template>
    </template>
  </yioks-content>
</template>

<script>
import {
  getAuditYouthPage,
  getAuditOrgPage,
  getAuditClubPage,
  toggleOrgRecommend,
  downloadBaseScoreSummaryFile,
  stageInfo,
  baseScoreFileListSummary,
  baseScoreFileList
} from "@/api/performance";
import trainCamp from "@/api/trainCamp";
import storage from "@/utils/storage";
import { stageTypeList, stageTypeListExtend } from "@/assets/js/yioksSelect";
import mixinAddressForSH from "@/mixin/mixinAddressForSH";
import mixinAppConfig from "@/mixin/mixinAppConfig";
import { auditStateFilters } from "@/assets/js/yioksFilters";
import { getExpertAuditYouthClubPage } from "@/api/export/index";
import { downloadByJs } from "@/utils/commen";
export default {
  mixins: [mixinAddressForSH, mixinAppConfig],
  components: {
    "sort-dialog": () =>
      import("@/views/performance/components/SortDialogForAdmin"),
    "upload-dialog": () => import("@/views/performance/components/uploadBaseScoreReport"),
    "upload-dialog-Summary": () => import("@/views/performance/components/uploadBaseScoreReportSummary"),
  },
  data() {
    return {
      pageList: [],
      // activeNav: "club",
      page: 0,
      pageSize: 20,
      total: 0,
      loading: false,
      empty: false,
      filterData: {
        stageName: "",
        stageApplyType: "",
        countyCode: "",
        cityCode: "",
        organUuid: ''
      },
      organList: [],
      isShowSortDialog: false,
      isUpload: false,
      isUploadSummary: false,
      editRow: {},
      isEditMode: false,
      youthUuid:"",
      stage_info:{}
    };
  },

  computed: {
    groupUuid() {
      const { groupUuid } = this.$route.query;
      return groupUuid || null;
    },

    stageUuid() {
      const { stageUuid } = this.$route.query;
      return stageUuid || null;
    },

    activeNav() {
      const { activeNav } = this.$route.query;
      return activeNav || null;
    },

    canEdit() {
      const { canEdit } = this.$route.query;
      return canEdit == "1" ? true : false;
    },

    // 推荐单位只能存在一个
    isRecommendExit() {
      const res = this.pageList.some((item) => {
        return item && item.adminRecommend;
      });
      return res;
    },

    propsType() {
      return this.activeNav ? this.activeNav.toUpperCase() : "YOUTH";
    },

    // stageSelectList() {
    //   return stageTypeList.concat(stageTypeListExtend);
    // },
  },

  filters: {
    empty(val) {
      if (val !== undefined) {
        return val;
      } else {
        return "--";
      }
    },
    auditStateFilters,
  },

  watch: {
    page() {
      this.changeQuery();
    },
  },

  created() {
    this.setFilterData();
    this.getOrgList();
    this.stageInfo();
    // this.changeQuery(true);
  },

  methods: {
    stageInfo(){
      stageInfo(this.stageUuid)
      .then((res) => {
        if (res.code) {
          this.$message.error(res.msg);
          return;
        }
        this.stage_info = res;
      })
      .catch((err) => {
        console.error("err", err);
      });
    },
    getBaseScoreFileSummary() {
      baseScoreFileListSummary(this.stageUuid)
      .then(res => {
        if(res.code) {
          this.$message.error(res.msg);
          return
        }
        if (res && res.length) {
          window.open(res[0].fileUrl)
        }else{
          this.$message.error('专家汇总表暂未上传');
        }
      })
      .catch(err => {
        this.isShowLoading = false;
        console.error('err', err)
      })
    },
    scoreSummaryFile(){
      this.isUploadSummary = true;
//      downloadBaseScoreSummaryFile(this.stageUuid)
//      .then(res => {
//        this.isShowLoading = false;
//        if(res.code) {
//          this.$message.error(res.msg);
//          return
//        }
//        const { fileName, filePath } = res;
//        const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
//        downloadByJs(transferPath, fileName);
//      })
//      .catch(err => {
//        this.isShowLoading = false;
//        console.error('err', err)
//      })
    },

    handleBack() {
      this.$router.go(-1);
    },
    setSelevtProvinceValue() {
      // 方法重写，别给删了
    },

    // 预设方法
    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.fullpath,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
        },
      });
      this.loadPageList();
    },

    // 设置参数
    setFilterData() {
      const { stageName, stageApplyType, countyCode, cityCode, organUuid } =
        this.$route.query;
      if (stageName) this.$set(this.filterData, "stageName", stageName);
      if (stageApplyType)
        this.$set(this.filterData, "stageApplyType", stageApplyType);
       if(organUuid) this.$set(this.filterData, "organUuid", organUuid);
      if (countyCode) this.$set(this.filterData, "countyCode", countyCode);
      if (cityCode) this.$set(this.filterData, "cityCode", cityCode);
    },

    // 加载列表请求方法
    loadPageList(flag = false) {
      const { stageName, organUuid, countyCode, cityCode, stageApplyType } =
        this.$route.query;
      const paramsData = {
        groupUuid: this.groupUuid,
        stageUuid: this.stageUuid,
        page: this.page,
        size: this.pageSize,
        stageName,
         organUuid,
        countyCode: countyCode ? countyCode : "0",
        cityCode,
        stageApplyType,
      };
      if (
        (!countyCode || countyCode == "0") &&
        (!cityCode || cityCode == "0")
      ) {
        paramsData.countyCode = "";
        paramsData.cityCode = "";
      }
      if (!flag) this.loading = true;
      let requestName = getExpertAuditYouthClubPage;
      // let requestName = getAuditYouthPage;
      // if (this.activeNav === "club") requestName = getAuditClubPage;
      // if (this.activeNav === "organ") requestName = getAuditOrgPage;
      // if (this.activeNav === "youth") requestName = getAuditYouthPage;
      // if (this.activeNav === "club") paramsData.type = "CLUB";
      // if (this.activeNav === "youth") paramsData.type = "YOUTH";

      if (requestName) {
        requestName(paramsData)
          .then((res) => {
            if (!flag) this.loading = false;
            if (res.code) {
              this.$msssage.error(res.msg);
              return;
            }
            const { content, empty, totalElements } = res;
            this.total = totalElements;
            this.empty = empty;
            this.pageList = content;
          })
          .catch((err) => {
            this.loading = false;
            this.empty = true;
            console.error("err", err);
          });
      } else {
        console.error("user type select error");
      }
    },

    handleListAction(type, row) {
      if (type === "audit") {
      } else if (type === "find") {
      } else if (type === "unSubmit") {
        this.$message.warning("用户未提交！");
        return;
      }
      const { groupUuid, stageUuid, youthUuid, youthName, youthShortName, audit } = row;
      this.$router.push({
        path: "unAuditTargetList",
        query: {
          groupUuid,
          stageUuid,
          youthUuid,
          youthName,
          youthShortName,
          audit,
        },
      });
    },
    goInfo (uuid) {
      this.$router.push({
        path: '/center/infoViewExpert',
        query: {
          uuid
        }
      })
    },
    uploadScoreReport(youth_uuid){
      this.youthUuid = youth_uuid;
      this.isUpload = true;
    },
    getBaseScoreFile(youth_uuid) {
      baseScoreFileList(youth_uuid,this.stageUuid)
      .then(res => {
        if(res.code) {
          this.$message.error(res.msg);
          return
        }
        if (res && res.length) {
          window.open(res[0].fileUrl)
        }else{
          this.$message.error('专家评分表暂未上传');
        }
      })
      .catch(err => {
        this.isShowLoading = false;
        console.error('err', err)
      })
    },
    // 提交弹窗回掉方法
    handleUploadCallBack(dialogStatus, confirmStatus) {
      this.isUpload = dialogStatus;
      if (confirmStatus) {
        if (!dialogStatus) {
          // this.changeQuery(true);

          this.isEditMode = false;
        } else {
          console.warn("call back error, dialog will be stay!");
        }
      } else {
        this.editRow = {};
      }

    },
    // 提交弹窗回掉方法
    handleUploadCallBackSummary(dialogStatus, confirmStatus) {
      this.isUploadSummary = dialogStatus;
      if (confirmStatus) {
        if (!dialogStatus) {
          // this.changeQuery(true);

          this.isEditMode = false;
        } else {
          console.warn("call back error, dialog will be stay!");
        }
      } else {
        this.editRow = {};
      }

    },

    getOrgList() {
      const userRole = storage.get("userInfo").userRole;
      const uuid = storage.get("userInfo").uuid;
      // eslint-disable-next-line no-unused-vars
      if (userRole === "system" || userRole === "admin") {
        console.log(111);
        trainCamp
          .getListBySystem({})
          .then((res) => {
            this.organList = res;
            if (this.organList.length === 1) {
              this.selectVal.organUuid = this.organList[0].uuid;
            }
            this.changeQuery(true);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.log(222);
        this.changeQuery(true);
//        trainCamp
//          .getListByOrg(uuid)
//          .then((res) => {
//            this.organList = res;
//            if (this.organList.length === 1) {
//              this.selectVal.organUuid = this.organList[0].uuid;
//            }
//
//          })
//          .catch((err) => {
//            console.log(err);
//          });
      }
    },

    // 打开排名弹窗
    handleEditSort() {
      if (this.pageList.length) {
        this.isShowSortDialog = true;
      } else {
        this.$message.warning("没有可参与申报评估排名的单位");
      }
    },

    // 排名弹窗回调
    handleCallback(flag) {
      if (flag) {
        this.changeQuery(true);
      }
    },

    // 推荐操作
    handleToggleRecommend(row) {
      const { uuid, organUuid, adminRecommendUuid } = row;
      let postData = {
        stageUuid: this.stageUuid,
        youthUuid: uuid,
        organUuid,
      };
      if (adminRecommendUuid) postData.uuid = adminRecommendUuid;
      toggleOrgRecommend(postData)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          this.loadPageList(true);
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    handleCountyChange(val) {
      if (val) {
        this.$set(this.filterData, "cityCode", "3101");
      } else {
        this.$set(this.filterData, "cityCode", "0");
      }
      this.changeQuery(true);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        min-height 45px
        height auto
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      /*height 100%*/
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        color $color_white
.seq
  width 5%
.youthName
  // width 22%
  width 32%
  display flex
  flex-direction column
// .youthShortName
// width 13%
.submit
  // width 10%
  width 18%
.audit
  width 10%
  text-align center
.score
  // width 9%
  width 17%
  text-align center
.auditScore
  width 8%
  text-align center
.orgAuditState
  width 11%
  text-align center
.adminAuditState
  width 11%
  text-align center
.action
  // width 16%
  flex 1
  .item
    cursor pointer
    user-select none
    &.active
      color $green_color
    &.danger
      color $red_color
  .split
    margin 0 5px
.ml10
  margin-left 10px
.ml5
  margin-left 5px
.suc
  color $green_color
</style>

<style lang="stylus" >
.y-input
  width 180px
  margin-right 20px
  input
    border-radius 0px !important
</style>
